import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Header, Modal, Divider } from 'semantic-ui-react';
import _ from 'lodash';

import ReactTableWrapper from 'Common/ReactTableWrapper';
import { Y } from 'Common/Constants';

import { columns as unmatchedTableColumns } from './UnmatchedTable';
import { PossibleMatchTable } from './PossibleMatchTable';

export class MatchModal extends Component {
  static props = {
    closeModal: PropTypes.func.isRequired,
    possibleMatches: PropTypes.array.isRequired,
    unmatched: PropTypes.object.isRequired,
    onMatchConfirmed: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
  };

  state = {
    selectedMatch: null,
  };

  get isConfirmStep() {
    return !!this.selectedMatchId;
  }

  handleMatchSelected = row => {
    const { selectedMatch } = this.state;

    if (_.get(row, 'Target.Id') === _.get(selectedMatch, 'Target.Id')) {
      this.resetMatchSelected();
      return;
    }

    this.setState({ selectedMatch: row });
  };

  resetMatchSelected = () => {
    this.setState({ selectedMatch: null });
  };

  get selectedMatchId() {
    return _.get(this.state.selectedMatch, 'Target.Id');
  }

  get selectedDeclinedBenefits() {
    return (
      _.get(this.state.selectedMatch, 'Target.Household.DeclineBenefits') === Y
    );
  }

  render() {
    const {
      closeModal,
      loading,
      possibleMatches,
      unmatched,
      onMatchConfirmed,
      onDeclinedBenefits,
    } = this.props;

    const { selectedMatchId } = this;

    const completeMessage = this.selectedDeclinedBenefits
      ? 'Delete Unmatched DC Import'
      : 'Complete Match';

    return (
      <Modal open closeIcon size="fullscreen" onClose={closeModal}>
        <Header icon="eye" content={`Choose a Match`} />
        <Modal.Content scrolling>
          <h5 className="text-orange">Unmatched DC Import</h5>
          <ReactTableWrapper
            data={[unmatched]}
            columns={unmatchedTableColumns}
            filterable={false}
            showPagination={false}
            minRows={1}
          />
          <Divider horizontal>
            <Header as="h4">
              {this.isConfirmStep
                ? `Match selected, press "${completeMessage}" to finish`
                : 'Select a match from the options below'}
            </Header>
          </Divider>

          <h5 className="text-orange">Possible Matches</h5>
          <PossibleMatchTable
            onRowSelect={this.handleMatchSelected}
            possibleMatches={possibleMatches}
            selectedMatchId={selectedMatchId}
            loading={loading}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="orange"
            content="Reset"
            onClick={this.resetMatchSelected}
            loading={this.isConfirmStep && loading}
            disabled={!this.isConfirmStep || loading}
          />
          <Button
            color="orange"
            content={completeMessage}
            onClick={() => {
              if (this.selectedDeclinedBenefits) {
                onDeclinedBenefits();
              } else {
                onMatchConfirmed(selectedMatchId);
              }
            }}
            loading={this.isConfirmStep && loading}
            disabled={!this.isConfirmStep || loading}
          />
          <Button
            color="orange"
            content="Cancel"
            onClick={closeModal}
            loading={this.isConfirmStep && loading}
            disabled={this.isConfirmStep && loading}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/dcunmatchedutility/components/MatchModal.js